var React = require('react');

function PaperIconInline (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M0 0.56C0 0.250721 0.223858 0 0.5 0H7.29289C7.4255 0 7.55268 0.0589998 7.64645 0.16402L8.75 1.4L9.85355 2.63598C9.94732 2.741 10 2.88344 10 3.03196V13.44C10 13.7493 9.77614 14 9.5 14H0.5C0.223858 14 0 13.7493 0 13.44V0.56Z","fill":"#C4C4C4"}));
}

PaperIconInline.defaultProps = {"width":"10","height":"14","viewBox":"0 0 10 14","fill":"none"};

module.exports = PaperIconInline;

PaperIconInline.default = PaperIconInline;
